import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import {
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline'

const OPTIONS = [
  { label: 'Chat with us', detail: 'Fastest response time', icon: ChatBubbleLeftRightIcon, href: undefined },
  { label: 'Email support', detail: 'Response within a few hours', icon: EnvelopeIcon, href: 'mailto:support@adlovin.ai' },
]

export default function HelpMenu() {
  return (
    <Popover>
      <PopoverButton
        aria-label="Help"
        data-tooltip="Help"
        data-tooltip-above=""
        className="flex size-10 shrink-0 items-center justify-center rounded-lg text-stone-500 transition-colors hover:bg-black/5 hover:text-stone-900 md:size-8"
      >
        <QuestionMarkCircleIcon className="size-4.5" />
      </PopoverButton>

      <PopoverPanel
        anchor={{ to: 'top start', gap: 6 }}
        transition
        className="z-50 w-72 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-[0_2px_4px_rgba(28,25,23,0.04),0_18px_44px_-16px_rgba(28,25,23,0.22)] transition duration-100 ease-out data-closed:translate-y-1 data-closed:opacity-0"
      >
        <div className="border-b border-stone-100 px-4 py-3">
          <p className="font-heading text-base font-semibold text-stone-900">We're here for you</p>
          <p className="text-xs text-stone-500">We'd love to hear from you.</p>
        </div>
        <div className="p-1">
          {OPTIONS.map(({ label, detail, icon: Icon, href }) => (
            <a
              key={label}
              href={href}
              className="flex items-center gap-3 rounded-lg px-3 py-2.5 transition-colors hover:bg-stone-100"
            >
              <Icon className="size-4.5 text-stone-400" />
              <span>
                <span className="block text-[13px] text-stone-900">{label}</span>
                <span className="block text-xs text-stone-500">{detail}</span>
              </span>
            </a>
          ))}
        </div>
      </PopoverPanel>
    </Popover>
  )
}
